import { useTranslation } from 'react-i18next';
import {
  useApiAdminsegmentscriteriaGetCollection,
  getApiAdminsegmentscriteriaGetCollectionQueryKey
} from '@r/api/generated/client.ts';
import type { SegmentCriterionSegmentCriterionReadModel } from '@r/api/generated/client.schemas.ts';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';

/**
 * Récupère la liste des critères disponibles pour construire des règles de segment
 * (champs, opérateurs et valeurs), mise en cache pendant 5 minutes.
 */
export const useSegmentCriteria = () => {
  const { t } = useTranslation();
  const criteriaQuery = useApiAdminsegmentscriteriaGetCollection({
    query: {
      queryKey: getApiAdminsegmentscriteriaGetCollectionQueryKey(),
      staleTime: 5 * 60 * 1000
    }
  });
  useOrvalQueryErrorToast(criteriaQuery, t('toast.error.label'));

  return {
    criteria: (criteriaQuery.data ?? []) as SegmentCriterionSegmentCriterionReadModel[],
    isLoading: criteriaQuery.isLoading
  };
};
